import type { Optimization, OptimizationType } from '../demo/types'
import { Badge } from './Badge'
import { Icon, type IconName } from './Icon'
import styles from './TimelineItem.module.css'

export interface TimelineItemProps {
  item: Optimization
  onUndo?: (id: string) => void
  onGo?: (target: string) => void
}

const typeLabel: Record<OptimizationType, string> = {
  product: '商品分析',
  audience: '受众',
  strategy: '创意策略',
  creative: '素材',
  compliance: '合规',
  needs_human: '需要你',
}

function actionLabel(target: string): string {
  return `去${target} →`
}

export function TimelineItem({ item, onUndo, onGo }: TimelineItemProps) {
  return (
    <div
      className={`${styles.item} ${item.type === 'needs_human' ? styles.human : ''} ${item.undone ? styles.undone : ''}`}
      data-component="timeline-item"
      data-op={item.id}
      data-tone={item.undone ? 'undone' : item.type === 'needs_human' ? 'human' : 'ai'}
    >
      <span className={styles.dot}><Icon name={item.icon as IconName} size={12} strokeWidth={2} /></span>
      <div className={styles.line1}>
        <span className={styles.time}>{item.at} · {typeLabel[item.type]}</span>
        <p className={styles.action}>{item.action}</p>
        {item.undone ? <Badge tone="gray" className={styles.undoneBadge}>已撤销</Badge> : null}
      </div>
      <div className={styles.line2}>
        <p className={styles.why}>{item.why}</p>
        {item.undone ? (
          <span className={`${styles.time} ${styles.control}`}>已撤销于 {item.undoneAt}</span>
        ) : item.type === 'needs_human' ? (
          <button type="button" className={styles.controlButton} onClick={() => onGo?.(item.target)}>{actionLabel(item.target)}</button>
        ) : onUndo ? (
          <button type="button" className={styles.controlButton} onClick={() => onUndo(item.id)}>撤销</button>
        ) : null}
      </div>
    </div>
  )
}
